'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.historyDataForThread = undefined;

var _reselect = require('reselect');

var _immutable = require('immutable');

var _getters = require('conversations-async-data/async-data/operators/getters');

var _setters = require('conversations-schema/thread-history/operators/setters');

var _getters2 = require('conversations-schema/thread-history/operators/getters');

var _historyForThread = require('./historyForThread');

var _getStubbedThreadHistory = require('../../stubbed-thread-history/selectors/getStubbedThreadHistory');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

var _isPersistedThread = require('../../threads/operators/isPersistedThread');

var _unpublishedMessagesForThread = require('../../pubsub/selectors/unpublishedMessagesForThread');

var historyDataForThread = exports.historyDataForThread = (0, _reselect.createSelector)([_historyForThread.historyForThread, _threadFromProps.threadFromProps, _getStubbedThreadHistory.getStubbedThreadHistory, _unpublishedMessagesForThread.unpublishedMessagesForThread], function (history, thread, stubbedThreadHistory, unpublishedMessages) {
  if (!(0, _isPersistedThread.isPersistedThread)(thread)) {
    return stubbedThreadHistory;
  }

  var historyData = (0, _getters.getData)(history);

  if (!historyData) {
    return null;
  }

  var messages = (0, _getters2.getMessages)(historyData) || (0, _immutable.OrderedMap)();

  if (messages.size < stubbedThreadHistory.messages.size) {
    return stubbedThreadHistory;
  }

  var fullMessages = messages.concat(unpublishedMessages);

  var fullHistoryData = (0, _setters.setMessages)(fullMessages, historyData);

  return fullHistoryData;
});